<template>
  <page-content title="Ubah Kata Sandi" :back-button="{ name: 'profile' }">
    <br />

    <div>
      <small>
        Dengan menggunakan SSO, ubah kata sandi tidak diperlukan pada aplikasi.
      </small>
    </div>
    <br />

    <c-input
      label="E-mail (tidak dapat diubah)"
      v-model="user.email"
      :readonly="true"
    />

    <c-input
      id="old-password"
      label="Kata Sandi Lama"
      type="password"
      v-model="form.oldPassword"
      :error="validations.oldPassword.error"
      :error-message="validations.oldPassword.message"
    />

    <c-input
      id="new-password"
      label="Kata Sandi Baru"
      type="password"
      placeholder="Minimal 5 karakter"
      v-model="form.newPassword"
      :error="validations.newPassword.error"
      :error-message="validations.newPassword.message"
    />

    <button
      class="btn btn-block btn-primary"
      @click="doSubmit"
      v-if="!isLoading"
    >
      Simpan
    </button>
    <p align="center" v-else>
      <pulse-loader :loading="isLoading" size="10px" :color="colorPrimary" />
    </p>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "profile-settings",
  data: function () {
    return {
      isLoading: false,
      form: {
        oldPassword: "",
        newPassword: "",
      },
      validations: {
        oldPassword: {
          error: false,
        },
        newPassword: {
          error: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    isFormValid: function () {
      // Reset the errors
      this.validations.oldPassword.error = false;
      this.validations.newPassword.error = false;

      if (this.isEmpty(this.form.oldPassword)) {
        this.validations.oldPassword.error = true;
        this.validations.oldPassword.message = "Kata Sandi Lama harus diisi.";
      }
      if (this.isEmpty(this.form.newPassword)) {
        this.validations.newPassword.error = true;
        this.validations.newPassword.message = "Kata Sandi Baru harus diisi.";
      }

      for (const key in this.validations) {
        const field = this.validations[key];
        if (field["error"]) return false;
      }
      return true;
    },
    doSubmit: function () {
      if (this.isFormValid()) {
        this.isLoading = true;
        this.$store
          .dispatch("updateUserPassword", this.form)
          .then(() => {
            // Reset form
            this.isLoading = false;
            this.form.oldPassword = "";
            this.form.newPassword = "";
            this.$toasted.success("Berhasil disimpan.");
          })
          .catch((error) => {
            const messages = error.response.data.message;
            if (messages.hasOwnProperty("old_password")) {
              this.validations.oldPassword.error = true;
              this.validations.oldPassword.message = messages.old_password[0];
            }
            if (messages.hasOwnProperty("new_password")) {
              this.validations.newPassword.error = true;
              this.validations.newPassword.message = messages.new_password[0];
            }
            this.isLoading = false;
          });
      }
    },
  },
  created: function () {},
};
</script>
